// General
import React, { Component } from 'react';
import PropTypes from 'prop-types';
// Redux Form
import { Field, reduxForm, formValueSelector, change } from 'redux-form';
// Redux
import { connect } from 'react-redux';
// Translation
import { injectIntl, FormattedMessage } from 'react-intl';
// Style
import withStyles from 'isomorphic-style-loader/withStyles';
import cx from 'classnames';
import {
  Row,
  FormGroup,
  Col,
  ControlLabel
} from 'react-bootstrap';

// Internal Component
import PlaceGeoSuggest from '../Common/GeoSuggest/PlaceGeoSuggest';
import CountryList from '../CountryList';
import StateList from '../StateList';
import FooterButton from './FooterButton';
import SidePanel from './SidePanel';



import { updateLocationStatus } from '../../actions/getLocation';
import { updateListingMap } from '../../actions/updateListingMap';
import { getLocationData } from '../../actions/getLocation';

// Locale
import messages from '../../locale/messages';
// Helpers
import validate from './validate';
import update from './update';

//Image
import toolTipIcon from '/public/SiteIcons/listCommonToolTip.svg';
import InputFieldComponent from '../Common/FormField/InputFieldComponent';
import bt from '../commonStyle.css';
import s from './ListPlaceStep1.css';
class Page5 extends Component {

  static propTypes = {
    initialValues: PropTypes.object,
    isLocationChosen: PropTypes.bool,
    previousPage: PropTypes.any,
    onSubmit: PropTypes.any,
    updateLocationStatus: PropTypes.any,
    nextPage: PropTypes.any,
    isExistingList: PropTypes.bool,
    updateListingMap: PropTypes.any,
    mapUpdateLoading: PropTypes.bool
  };


  constructor(props) {
    super(props);
    this.state = {
      prevCountry: null
    };
    this.renderCountryList = this.renderCountryList.bind(this);
  }


  // UNSAFE_componentWillMount() {
  //   const { isExistingList, isLocationChosen } = this.props;
  //   if (!isLocationChosen && !isExistingList) {
  //     this.setState({ hideSuggestInput: false });
  //   }
  // }

  onSuggestSelect = (data, value) => {
    return data ? this.props.getLocationData(value) : '';
  }

  componentDidUpdate(prevProps) {
    const { country, change } = this.props;
    
    // Clear state field when switching to/from TN (different input types)
    if (country !== prevProps.country && (prevProps.country === 'TN' || country === 'TN')) {
      if (change) {
        change('ListPlaceStep1', 'state', '');
      }
    }
    
    // Set coordinates based on country
    if (country !== prevProps.country && change) {
      if (country === 'TN') {
        // Tunisia coordinates
        change('lat', 36.8065);
        change('lng', 10.1815);
      } else if (country) {
        // USA coordinates (default for other countries)
        change('lat', 39.8283);
        change('lng', -98.5795);
      }
    }
  }

  onSuggestSelect = (data, value) => {
    return data ? this.props.getLocationData(value) : '';
  }

  renderPlacesSuggest = ({ input, label, meta: { touched, error }, className }) => {
    const { formatMessage } = this.props.intl;
    return (
      <div>
        {touched && error && <span>{formatMessage(error)}</span>}
        <PlaceGeoSuggest
          {...input}
          placeholder={label}
          className={className}
          id={'becomeHost'}
          onSuggestSelect={this.onSuggestSelect}
          containerClass="becomeHostGeoSuggest"
        />
      </div>
    )
  }

  renderCountryList({ input, label, meta: { touched, error }, children, className }) {
    const { formatMessage } = this.props.intl;
    return <div>
      <CountryList input={input} className={className} isEmptyFirst disabled />
      {touched && error && <span className={s.errorMessage}>{formatMessage(error)}</span>}
    </div >
  }

  renderStateList = ({ input, label, meta: { touched, error }, children, className }) => {
    const { formatMessage } = this.props.intl;
    return (
      <div>
        <StateList input={input} className={className} isEmptyFirst />
        {touched && error && <span className={s.errorMessage}>{formatMessage(error)}</span>}
      </div>
    );
  }

  renderStateField = ({ input, label, meta: { touched, error }, children, className }) => {
    const { formatMessage } = this.props.intl;
    const { country } = this.props; // Get country value from props
    
    // If country is Tunisia (TN), show dropdown, otherwise show text input
    if (country === 'TN') {
      return (
        <div>
          <StateList input={input} className={cx(bt.commonControlSelect, 'commonControlSelectRtl')} isEmptyFirst />
          {touched && error && <span className={s.errorMessage}>{formatMessage(error)}</span>}
        </div>
      );
    } else {
      return (
        <div>
          <InputFieldComponent 
            input={input}
            meta={{ touched, error }}
            inputClass={bt.commonControlInput}
            placeholder={formatMessage(messages.state)}
          />
          {touched && error && <span className={s.errorMessage}>{formatMessage(error)}</span>}
        </div>
      );
    }
  }


  renderLocationInput = () => {
    const { updateLocationStatus, nextPage, previousPage, loading, formPage, step, listId } = this.props;
    const { formatMessage } = this.props.intl;
    return (
      <div>
        <div className={cx(s.grid, 'becomeHost')}>
          <SidePanel
            title={formatMessage(messages.stepOneCommonHeading)}
            landingContent={formatMessage(messages.whereLocatedContent)}
          />
          {
            !listId && <div className={s.landingMainContent}>
              <FormGroup className={cx('fullAddressSection', s.space3)}>
                <ControlLabel className={cx(s.landingLabel)}>
                  <FormattedMessage {...messages.yourLocationLabel} />
                </ControlLabel>
                <Field
                  name="location"
                  component={this.renderPlacesSuggest}
                  label={formatMessage(messages.searchYourLocation)}
                  className={cx(bt.commonControlInput, s.becomeHostLocationSelect, 'prefixIconInputRtl')}
                />
              </FormGroup>
              <div className={s.tipCommonCss}>
                <img src={toolTipIcon} />
                <span className={cx(s.commonTipCsss)}><FormattedMessage {...messages.yourLocationLabelDesc} /></span>
              </div>
            </div>
          }

        </div>

        <FooterButton
          nextPage={updateLocationStatus}
          previousPage={previousPage}
          previousPagePath={"bedrooms"}
          formPage={formPage}
          step={step}
        />

      </div>
    );
  }

  renderLocationForm = () => {
    const { isExistingList, nextPage, previousPage, onSubmit, invalid, updateListingMap, loading, mapUpdateLoading, country } = this.props;
    const { formatMessage } = this.props.intl;
    const { error, handleSubmit, submitting, valid, formPage, step } = this.props;
    let isDisabled = true;
    if (valid) {
      isDisabled = false;
    }
    return (
      <div>
        <div className={s.grid}>
          <SidePanel
            title={formatMessage(messages.stepOneCommonHeading)}
            landingContent={formatMessage(messages.whereLocatedContent)}
          />
          <div className={s.landingMainContent}>
            <FormGroup className={s.space5}>
              <ControlLabel className={cx(s.landingLabel)}>
                <FormattedMessage {...messages.country} />
              </ControlLabel>
              <Field name="country" component={this.renderCountryList} className={cx(bt.commonControlSelect, 'commonControlSelectRtl')} />
            </FormGroup>
            {/* <FormGroup className={s.space5}>
              <ControlLabel className={cx(s.landingLabel)}>
                <FormattedMessage {...messages.street} />
              </ControlLabel>
              <Field
                name="street"
                component={InputFieldComponent}
                inputClass={bt.commonControlInput}
                placeholder={formatMessage(messages.street)}
              />
            </FormGroup> */}
            {/* <FormGroup className={s.space5}>
              <ControlLabel className={cx(s.landingLabel)}>
                <FormattedMessage {...messages.buildingName} />
              </ControlLabel>
              <Field
                name="buildingName"
                component={InputFieldComponent}
                inputClass={bt.commonControlInput}
                placeholder={formatMessage(messages.buildingName)}
              />
            </FormGroup> */}
            <Row>
              <Col xs={12} sm={12} md={12} lg={6}>
                <FormGroup className={s.space5}>
                  <ControlLabel className={cx(s.landingLabel)}>
                    <FormattedMessage {...messages.city} />
                  </ControlLabel>
                  <Field
                    name="city"
                    component={InputFieldComponent}
                    inputClass={bt.commonControlInput}
                    placeholder={formatMessage(messages.city)}

                  />
                </FormGroup>
              </Col>
              <Col xs={12} sm={12} md={12} lg={6}>
                <FormGroup className={s.space5}>
                  <ControlLabel className={cx(s.landingLabel)}>
                    <FormattedMessage {...messages.state} />
                  </ControlLabel>
                  <Field 
                    name="state" 
                    key={`state-${country || 'default'}`}
                    component={this.renderStateField}
                  />
                </FormGroup>
              </Col>
            </Row>
            {/* <FormGroup className={s.space5}>
              <Row>
                <Col xs={12} sm={6} md={6} lg={6}>
                  <ControlLabel className={cx(s.landingLabel)}>
                    <FormattedMessage {...messages.zipcode} />
                  </ControlLabel>
                  <Field
                    name="zipcode"
                    component={InputFieldComponent}
                    inputClass={bt.commonControlInput}
                    placeholder={formatMessage(messages.zipcode)}
                  />
                </Col>
              </Row>
            </FormGroup> */}
            
          </div>
        </div>

        <FooterButton
          isDisabled={isDisabled}
          previousPage={previousPage}
          previousPagePath={"bedrooms"}
          type={"location"}
          updateListingMap={updateListingMap}
          formPage={formPage}
          step={step}
        />

      </div>
    );
  }

  render() {

    const { error, handleSubmit, submitting, pristine, previousPage, onSubmit, nextPage } = this.props;
    const { isLocationChosen, isExistingList } = this.props;
    const { formatMessage } = this.props.intl;

    return (
      <div>
        <form onSubmit={handleSubmit}>
          {error && <strong>{formatMessage(error)}</strong>}
          {this.renderLocationForm()}
        </form>
      </div>
    );
  }
}

Page5 = reduxForm({
  form: 'ListPlaceStep1', // a unique name for this form
  destroyOnUnmount: false,
  forceUnregisterOnUnmount: true,
  validate,
  onSubmit: update
})(Page5);

const selector = formValueSelector('ListPlaceStep1');

const mapState = (state) => ({
  isLocationChosen: state.location.isLocationChosen,
  isExistingList: state.location.isExistingList,
  loading: state.loader.location,
  mapUpdateLoading: state.location.mapUpdateLoading,
  country: selector(state, 'country'),
  lat: selector(state, 'lat'),
  lng: selector(state, 'lng')
});

const mapDispatch = {
  updateLocationStatus,
  updateListingMap,
  getLocationData,
  change
};

export default injectIntl(withStyles(bt, s)(connect(mapState, mapDispatch)(Page5)));